export default {"src":"/_next/static/media/help-tile.bb1d68b4.svg","height":240,"width":239};